export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-pink-500 via-purple-500 to-yellow-500 text-white py-12 sm:py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12 mb-8 sm:mb-12">
          {/* Logo and Description */}
          <div className="sm:col-span-2">
            <div className="flex items-center space-x-3 mb-4 sm:mb-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/6b1b462e-7702-4dd8-a6c7-86963b54e045.png" 
                alt="キッズPCスクール" 
                className="h-10 sm:h-12 w-auto bg-white rounded-lg p-1"
              />
            </div>
            <p className="text-white/90 text-base sm:text-lg leading-relaxed mb-4 sm:mb-6">
              非エンジニアのパパが娘の将来を思って作った、<br />
              世界一やさしいPCスクール
            </p>
            <div className="flex space-x-3 sm:space-x-4">
              <a href="#" className="w-10 sm:w-12 h-10 sm:h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-all duration-300 cursor-pointer">
                <i className="ri-facebook-fill text-xl sm:text-2xl"></i>
              </a>
              <a href="#" className="w-10 sm:w-12 h-10 sm:h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-all duration-300 cursor-pointer">
                <i className="ri-twitter-x-fill text-xl sm:text-2xl"></i>
              </a>
              <a href="#" className="w-10 sm:w-12 h-10 sm:h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-all duration-300 cursor-pointer">
                <i className="ri-instagram-fill text-xl sm:text-2xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-black text-lg sm:text-xl mb-4 sm:mb-6">クイックリンク</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li><a href="#features" className="text-white/80 hover:text-white transition-colors duration-300 cursor-pointer text-sm sm:text-base">スクールの特徴</a></li>
              <li><a href="#pricing" className="text-white/80 hover:text-white transition-colors duration-300 cursor-pointer text-sm sm:text-base">料金プラン</a></li>
              <li><a href="#testimonials" className="text-white/80 hover:text-white transition-colors duration-300 cursor-pointer text-sm sm:text-base">保護者の声</a></li>
              <li><a href="#faq" className="text-white/80 hover:text-white transition-colors duration-300 cursor-pointer text-sm sm:text-base">よくある質問</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-black text-lg sm:text-xl mb-4 sm:mb-6">お問い合わせ</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li className="flex items-start space-x-2 sm:space-x-3">
                <i className="ri-map-pin-fill text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                <span className="text-white/80 text-sm sm:text-base">大阪府大阪市北区梅田</span>
              </li>
              <li className="flex items-start space-x-2 sm:space-x-3">
                <i className="ri-mail-fill text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                <span className="text-white/80 text-sm sm:text-base break-all">info@kids-pc-school.jp</span>
              </li>
              <li className="flex items-start space-x-2 sm:space-x-3">
                <i className="ri-phone-fill text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                <span className="text-white/80 text-sm sm:text-base">06-1234-5678</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-6 sm:pt-8 flex flex-col md:flex-row items-center justify-between space-y-3 sm:space-y-4 md:space-y-0">
          <p className="text-white/70 text-xs sm:text-sm text-center md:text-left">
            © 2024 キッズPCスクール. All rights reserved.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-6">
            <a href="#" className="text-white/70 hover:text-white text-xs sm:text-sm transition-colors duration-300 cursor-pointer whitespace-nowrap">プライバシーポリシー</a>
            <a href="#" className="text-white/70 hover:text-white text-xs sm:text-sm transition-colors duration-300 cursor-pointer whitespace-nowrap">利用規約</a>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white text-xs sm:text-sm transition-colors duration-300 cursor-pointer whitespace-nowrap">Powered by Readdy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
